// siteLanguage — the language a first-time visitor starts in (the store's
// default), known from the site-context answer (`default_language`) before
// /api/public/languages has been fetched. Starting in it means the very first
// requests (translations, page designs, items) already carry the right ?lang=,
// instead of running once without it and again after the language list arrives.
// "" = unknown (older backend, or no default marked): behaviour as before.
import { langFromPath } from "./langPath";

let siteDefaultLanguage = "";

export function setSiteDefaultLanguage(code) {
  siteDefaultLanguage = typeof code === "string" ? code : "";
}

export function getSiteDefaultLanguage() {
  return siteDefaultLanguage;
}

// The language the app should start in when the visitor has no remembered
// choice and the address has no language prefix (/ar/...): the default one.
export function startingLanguage() {
  try {
    if (langFromPath(window.location.pathname)) return "";
  } catch {
    return "";
  }
  return siteDefaultLanguage;
}
